import { combineReducers } from 'redux';

import pipelinesState, { pipelinesInitialState } from './pipelines';
import tasksState, { tasksInitialState } from './tasks';

export const listInitialState = { 
  pipelinesState: pipelinesInitialState,
  tasksState: tasksInitialState,
}
export default combineReducers({ tasksState, pipelinesState })